import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import {
  canImpersonate,
  MANAGEMENT_FALLBACK_ROUTE,
} from '@/lib/utils/managementAccess';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';
import { ImpersonatePanel } from '../-components/ImpersonatePanel';

export const Route = createFileRoute('/management/impersonate/(pages)/')({
  // The parent `/management` guard only checks `canAccessManagement` now — it
  // admits any Retraced staff, not just those who may impersonate. This page
  // re-checks `canImpersonate` itself, since it's the one tool in the area
  // that isn't meant for every internal role.
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!canImpersonate(user))
      throw redirect({ to: MANAGEMENT_FALLBACK_ROUTE });
  },
  component: ManagementImpersonatePage,
});

function ManagementImpersonatePage() {
  // `PageContainer` brings `flex-1 min-h-0 overflow-hidden`, which is what lets
  // the panel own the full height and scroll its own rows.
  return (
    <PageContainer>
      <ImpersonatePanel />
    </PageContainer>
  );
}
